/**
 * 예정일 표시: 미정이면 「미정」, 아니면 날짜. 둘 다 없으면 빈 글자. (DOM-PART-001 5.3 「완료예정일 칸」)
 * - 부품수리완료예정일·작업완료예정일처럼 날짜와 미정 여부를 따로 받는 값에 쓴다. 「완료미정」이라 쓰지 않는다.
 * - 그리드는 조회 뒤 글자 칸(`…Text`)에 넣어 두어 엑셀에도 「미정」이 나오게 하고, 정렬은 날짜로 한다.
 * - 「미정」의 색(fw-semibold text-warning-emphasis)은 화면 템플릿에서 준다.
 */
export function dateOrUnknown(date?: string | null, unknown?: boolean | null): string {
  return unknown ? '미정' : (date ?? '');
}
